import {createContext} from "react";

export const PortalContext = createContext<Element|undefined>(undefined);